<tabset #artabset type="tabs" class="tabs-animated tabs-animated-shadow tabs-bordered" [justified]="true">
  <tab id="arAssignedTab">
    <ng-template tabHeading>
      <span> To Be Billed Customer Transactions</span>
    </ng-template>
    <app-customer-assigned></app-customer-assigned>
  </tab>
  <tab id="arPaid">
    <ng-template tabHeading>
      <span>Customer Paid Transactions</span>
    </ng-template>
    <app-customer-paid> </app-customer-paid>
  </tab>
</tabset>
